import { ChevronDownIcon, UIText } from '@/component-library';
import {
  PropsWithChildren,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
import * as S from './accordion.style';
import { AccordionContext } from './AccordionProvider';

export const ExpandableArticle: React.FC<
  PropsWithChildren<{
    title: string;
    value: string;
    minHeight?: number;
  }>
> = ({ title, value, minHeight = 0, children }) => {
  const [openValue, s_open] = useContext(AccordionContext),
    open = openValue === value,
    contentRef = useRef<HTMLDivElement>(null),
    dataState = open ? 'open' : 'closed';

  function setContentHeight(open: boolean) {
    let content = contentRef.current,
      height = `${minHeight}px`,
      display = 'none';
    if (!content) return;

    if (open) {
      height =
        (minHeight > content.scrollHeight ? minHeight : content.scrollHeight) +
        'px';
      display = 'block';
    }
    content.style.maxHeight = height;
    content.style.display = display;
  }

  const handleClick = useCallback(() => {
    if (!contentRef.current || !s_open) return;
    const newOpen = !open;
    setContentHeight(newOpen);
    s_open(newOpen ? value : '');
  }, [open]);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(open);
    }
  }, [open]);

  return (
    <S.AccordionArticle>
      <S.Trigger isExpandable onClick={handleClick}>
        <UIText size="lg" as="h2">
          {title}
        </UIText>
        <ChevronDownIcon data-state={dataState} width="16" aria-hidden />
      </S.Trigger>
      <S.Content ref={contentRef}>{children}</S.Content>
    </S.AccordionArticle>
  );
};
